export default __webpack_public_path__ + "static/media/robart.9416d39b.jpg";